import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';

/**
 * Wraps every `Image` field in a centered, rounded "card".
 *
 * Registered as the default wrapper for the `image` type in app.module.ts, so
 * it applies uniformly to all images (e.g. the Condition panel's
 * `HeatpumpImage` and the Conditions tab's `ConditionDiagramImage`) — the
 * card look is purely presentational and independent of the field's position,
 * which is instead controlled by the generic `colspan`/`orientation` layout
 * engine in FormlyHelper.ts.
 */
@Component({
  selector: 'formly-image-card-wrapper',
  imports: [FormlyModule],
  host: { style: 'display: block; height: 100%;' },
  template: `
    <div class="image-card">
      <ng-container #fieldComponent></ng-container>
    </div>
  `,
  styles: [
    `
      .image-card {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        border-radius: 0.75rem;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageCardWrapperComponent extends FieldWrapper {}
